import useModal from '@area2k/use-modal';

import AddressSection from './AddressSection';
import DefaultContactSection from './DefaultContactSection';
import MarkupSection from './MarkupSection';
import UpdateContactModal from './UpdateContactModal';

import Card from '@/components/Card';
import { FEATURE_TOGGLE } from '@/constants/featuretoggle';
import { AccountRateTypeEnum, GetAccountQuery } from '@/types/graphql';
import { useFeatureValue } from '@growthbook/growthbook-react';
import AdditionalEmailSection from './AdditionalEmailSection';

type Props = {
  account: GetAccountQuery['account'];
  phoneOnly?: boolean;
};

const ProfileCard = ({ account, phoneOnly = false }: Props) => {
  const AdditionalBillingToggle = useFeatureValue(
    FEATURE_TOGGLE.AdditionalBillingEmail,
    false,
  );
  const [showCreateModal, hideCreateModal] = useModal(
    () => (
      <UpdateContactModal
        account={account}
        hideModal={hideCreateModal}
        rateType={createModalType}
      />
    ),
    [account],
  );

  const createModalType =
    account?.markupPercent && account?.rateType === AccountRateTypeEnum.MARKUP
      ? AccountRateTypeEnum.MARKUP
      : AccountRateTypeEnum.STATIC;

  const hasAddress =
    !!account.addressLine1 &&
    !!account.city &&
    !!account.state &&
    !!account.zip;

  return (
    <Card
      actions={[
        {
          a11yLabel: 'Change Contact',
          label: 'Change',
          onAction: showCreateModal,
          id: 'btn-change-contact',
        },
      ]}
      noRadius={phoneOnly}
      title="Primary Contact"
    >
      <DefaultContactSection account={account} />
      {AdditionalBillingToggle &&
        account.additionalEmails &&
        account.additionalEmails?.length > 0 && (
          <AdditionalEmailSection additionalEmails={account.additionalEmails} />
        )}
      {hasAddress && <AddressSection account={account} />}
      {account?.markupPercent && account?.rateType === 'MARKUP' ? (
        <MarkupSection markupValue={account?.markupPercent} />
      ) : null}
    </Card>
  );
};

export default ProfileCard;
